import { observer } from 'mobx-react-lite';
import AlertsManagerDark from 'src/packages/assets/icons/alerts-manager-widget-dark.svg?react';
import AlertsManagerLight from 'src/packages/assets/icons/alerts-manager-widget-light.svg?react';
import AnalyzeIconDark from 'src/packages/assets/icons/analyze-widget-dark.svg?react';
import AnalyzeIconLight from 'src/packages/assets/icons/analyze-widget-light.svg?react';
import ArrowVertIcon from 'src/packages/assets/icons/arrow-vert-directions.svg?react';
import BroadcastIconDark from 'src/packages/assets/icons/broadcast-widget-dark.svg?react';
import BroadcastIconLight from 'src/packages/assets/icons/broadcast-widget-light.svg?react';
import ClockIcon from 'src/packages/assets/icons/clock.svg?react';
import DayDepthWidgetDark from 'src/packages/assets/icons/day-depth-widget-dark.svg?react';
import DayDepthWidgetLight from 'src/packages/assets/icons/day-depth-widget-light.svg?react';
import DepthIcon from 'src/packages/assets/icons/depth.svg?react';
import DetailIconDark from 'src/packages/assets/icons/detail-widget-dark.svg?react';
import DetailIconLight from 'src/packages/assets/icons/detail-widget-light.svg?react';
import DirectionalDark from 'src/packages/assets/icons/directional-dark.svg?react';
import DirectionalLight from 'src/packages/assets/icons/directional-light.svg?react';
import GraphIconDark from 'src/packages/assets/icons/graph-dark.svg?react';
import GraphIconLight from 'src/packages/assets/icons/graph-light.svg?react';
import HeatmapIconDark from 'src/packages/assets/icons/heatmap-widget-dark.svg?react';
import HeatmapIconLight from 'src/packages/assets/icons/heatmap-widget-light.svg?react';
import MultiAnalysisDark from 'src/packages/assets/icons/multi-analysis-dark.svg?react';
import MultiAnalysisLight from 'src/packages/assets/icons/multi-analysis-light.svg?react';
import OperationalParamsDark from 'src/packages/assets/icons/operational-params-dark.svg?react';
import OperationalParamsLight from 'src/packages/assets/icons/operational-params-light.svg?react';
import TrajectoryDark from 'src/packages/assets/icons/trajectory-widget-dark.svg?react';
import TrajectoryLight from 'src/packages/assets/icons/trajectory-widget-light.svg?react';
import VideoDark from 'src/packages/assets/icons/video-dark.svg?react';
import VideoLight from 'src/packages/assets/icons/video-light.svg?react';
import WellCorrelationDark from 'src/packages/assets/icons/well-correlation-widget-dark.svg?react';
import WellCorrelationLight from 'src/packages/assets/icons/well-correlation-widget-light.svg?react';

import { ThemeStore } from 'src/app/theme/ThemeStore';

import type { TIcon } from '../NewContentWidgetModal.store';

import styles from './WidgetAndGroupPanel.module.scss';

type Props = {
  iconName?: TIcon;
};

export const PanelIcon = observer(function PanelIcon({ iconName }: Props) {
  if (!iconName) {
    return null;
  }

  const { theme } = new ThemeStore();

  switch (iconName) {
    case 'empty': {
      return null;
    }
    case 'clock': {
      return <ClockIcon />;
    }
    case 'vertArrow': {
      return <ArrowVertIcon />;
    }
    case 'depth': {
      return <DepthIcon />;
    }
    case 'detail': {
      return <div>{theme === 'dark' ? <DetailIconDark /> : <DetailIconLight />}</div>;
    }
    case 'analyze': {
      return <div>{theme === 'dark' ? <AnalyzeIconDark /> : <AnalyzeIconLight />}</div>;
    }
    case 'broadcast': {
      return <div>{theme === 'dark' ? <BroadcastIconDark /> : <BroadcastIconLight />}</div>;
    }
    case 'graph': {
      return <div className={styles.graphIconWrapper}>{theme === 'dark' ? <GraphIconDark /> : <GraphIconLight />}</div>;
    }
    case 'operational': {
      return (
        <div className={styles.graphIconWrapper}>
          {theme === 'dark' ? <OperationalParamsDark /> : <OperationalParamsLight />}
        </div>
      );
    }
    case 'directional': {
      return <div>{theme === 'dark' ? <DirectionalDark /> : <DirectionalLight />}</div>;
    }
    case 'video': {
      return <div>{theme === 'dark' ? <VideoDark /> : <VideoLight />}</div>;
    }
    case 'day-vs-depth': {
      return <div>{theme === 'dark' ? <DayDepthWidgetDark /> : <DayDepthWidgetLight />}</div>;
    }
    case 'heatmap': {
      return <div>{theme === 'dark' ? <HeatmapIconDark /> : <HeatmapIconLight />}</div>;
    }
    case 'drilling-multi-analysis': {
      return <div>{theme === 'dark' ? <MultiAnalysisDark /> : <MultiAnalysisLight />}</div>;
    }
    case 'alerts-manager': {
      return <div>{theme === 'dark' ? <AlertsManagerDark /> : <AlertsManagerLight />}</div>;
    }
    case 'well-correlation': {
      return <div>{theme === 'dark' ? <WellCorrelationDark /> : <WellCorrelationLight />}</div>;
    }
    case 'trajectory': {
      return <div>{theme === 'dark' ? <TrajectoryDark /> : <TrajectoryLight />}</div>;
    }
  }
});
